// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.blink[data-v-34144cf0] {\n\tanimation: blinking-34144cf0 ease-out 1s infinite;\n}\n@keyframes blinking-34144cf0 {\n0% {\n\t\tbackground-color: var(--v-primary-base);\n}\n100% {\n\t\tbackground-color: #fff;\n}\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
